import { webApi } from 'src/services/api/config'
import { AxiosResponse } from 'axios'

/**
 * Changes users password
 */
export const postResetPassword = async (
  data: FormData
): Promise<AxiosResponse> => {
  return await webApi.post('api/PasswordReset/Reset', data)
}

/**
 * Gets password reset token data
 */
export const getPasswordResetToken = async (
  token: string
): Promise<AxiosResponse> => {
  return await webApi.get(`api/PasswordReset/Token/${token}`)
}
